<template>
    <section>
        <MainLayout>
			<div class="container">
				<div class="box">
					<section>
						<b-overlay :show="loadingExport" no-wrap/>
						<form class="container">
							<b-form-row>
								<b-form-group class="col-lg-3 col-12" :label="$t('bookings.serviceDateFrom')">
									<b-form-datepicker :locale="$root.store.state.currentUser.lang" :class="{'active-filter':filters.pickupStartDate}" reset-button size="sm" v-model="filters.pickupStartDate"/>
								</b-form-group>

								<b-form-group class="col-lg-3 col-12" :label="$t('bookings.serviceDateTo')">
									<b-form-datepicker :locale="$root.store.state.currentUser.lang" :class="{'active-filter':filters.pickupEndDate}" reset-button  size="sm" v-model="filters.pickupEndDate"/>
								</b-form-group>

								<b-form-group class="col-lg-3 col-12" :label="$t('saleChannel.saleChannel')">
									<FilterSaleChannel v-model="filters.salesChannels"></FilterSaleChannel>
								</b-form-group>

								<b-form-group class="col-lg-3 col-12" :label="$t('reports.promotions')">
									<b-form-checkbox
										id="checkbox-1"
										v-model="filters.withPromo"
										name="promo"
										>
										{{ $t('reports.withPromotion') }}
									</b-form-checkbox>
								</b-form-group>
								

								<b-form-group class="col-md-3" :label="$t('bookings.serviceStatus')">
									<multiselect
										:class="{'active-filter':filters.status.length>0}"
										v-model="filters.status"
										:options="statusOpts"
										group-label="group"
										group-values="options"
										group-select
										multiple
										label="text"
										track-by="value"
										:placeholder="$t('global.all')"
										taggable
									/>
								</b-form-group>

								<b-form-group class="col-lg-3 col-12" label=".">
									<b-form-checkbox
									v-model="filters.ratesInZero"
									value="1"
									unchecked-value="0"
									>
										Tarifas en 0
									</b-form-checkbox>
								</b-form-group>

								<div class="col mt-lg-3">
									<b-button variant="outline-primary" type="button" @click="checkform()" class="m-2" v-b-tooltip.hover :title="$t('global.search')"><md-icon icon="search"/></b-button>
									<b-button variant="outline-success" type="button" @click="exportSpreadSheet()" v-b-tooltip.hover :title="$t('bookings.export')"><md-icon icon="note_add"/></b-button>
								</div>
							</b-form-row>
						</form>
					</section>
					<br>
					<b-overlay :show="loading">
						<section v-if="pagination.totalRows>0">
							<section v-if="$root.isTransportist && pagination.perPage<=50"  >
								<div class="d-flex justify-content-end  mb-2 fixed-bottom " style="margin-right: 6%;" v-if="editing ">
									<b-button
											variant="secondary"
											class="ml-2 mb-2"
											@click="deactivateEditing"
										>
											<span>{{ $t("global.cancel") }}</span>
									</b-button>
									<b-button
											size="lg"
											variant="success"
											class="ml-2 mb-2"
											@click="updateAllView"
										>
											{{ $t("reports.saveRates") }} ({{ ridesToUpdate.length }})
										</b-button>
								</div>
								
								<b-row>
									<b-col class="text-right">
										<b-button
											variant="warning"
											class="ml-2 mb-2"
											@click="activateEditing"
											v-if="!editing"
										>
											<span>{{ $t("reports.editRates") }}</span>
										</b-button>
									</b-col>
								</b-row>
							</section>
							<b-row>
								<b-col sm class="mt-2">
									<div class="mr-4">
										{{rowsMessage}}
										<b-form-select size="sm" class="ml-2" style="width:80px" v-model="pagination.perPage" :options="pagination.perPageOptions" @change="paginationChanged"></b-form-select>
									</div>
								</b-col>
								<b-col sm class="float-right">
									<b-row no-gutters>
										<b-col >
											<b-pagination
												align="right"
												v-model ="pagination.currentPage"
												:total-rows ="pagination.totalRows"
												:per-page="pagination.perPage"
												@change="paginationChanged"
											/>
										</b-col>
									</b-row>
								</b-col>
								
							</b-row>
							<b-table
							:sticky-header="true"
							striped
							hover
							small
							ref="tblReportRides"
							:fields="tbl.fields"
							:items.sync="itemsRides"
							:empty-text="$t('global.ajaxTable.noRecordsFound')"
							show-empty
							stacked="lg"
							>
								<template #thead-top="">
									<b-tr>
										<b-th colspan="200"><span class="sr-only">Name and ID</span>
											<span variant="success" class="float-right text-success">
												Payment amount<sup>*</sup>
												<md-icon icon="price_change" style="margin-bottom:-2px" /> {{willBePaidText}}
											</span>
										</b-th>
									</b-tr>
								</template>
								<template #cell(status)="row">
									<span :class="getClassForStatus(row.item.status)"><b>{{$t("transportServiceStatus."+row.item.status)}}</b></span>
								</template>
								<template #cell(revenue)="row">
									<span :class="{ 'text-danger': (row.item.revenue<0) }"><b>{{row.item.revenue}}</b></span>
								</template>
								<template #cell(revenueCurrency)="row">
									<span class="text-uppercase">{{row.item.revenueCurrency}}</span>
								</template>
								<template #cell(revenueCalculate)="row">
									<section v-if="row.item.operatedBy=='supplier'">
										<b-input-group size="sm">
											<b-form-input
												type="text"
												size="sm"
												v-model="row.item.supplierPriceTotalUpdated"
											/>
											<template #prepend>
												<b-input-group-text>$</b-input-group-text>
											</template>
											<template #append>
												<b-button
													:title="$t('reports.calculateRate')"
													@click="event => calculatePrice(row.item)"
													type="button"
													size="sm"
													class="mr-1" 
													variant="info"
												>
													<b-spinner
														small
														v-if="loadingRow === row.item.id"
													/>
													<md-icon v-else icon="refresh"></md-icon>
												</b-button>
												<b-button v-if="trace.lastCalculated === row.item.id" @click="openModalTrace">
													<md-icon  icon="info_outline"  ></md-icon>
												</b-button>
											</template>
										</b-input-group>
									</section>
									<section v-else class="text-center">
										<md-icon :icon="'lock'"></md-icon>
									</section>
								</template>
							</b-table>
						</section>
						<section v-else>
							{{$t('global.ajaxTable.noRecordsFound')}}
						</section>
					</b-overlay>
				</div>
			</div>
			<b-modal id="trace-data" ref="trace-data" size="xl" ok-only ok-title="Cerrar">
				<h4>Detalles</h4>
				<section>
					<b-table responsive="md" stacked="sm"   show-empty small striped hover :items="trace.items" :fields="trace.columns" >
						<template #cell(ratePlanId)="row">
							<b-form-checkbox v-model="row.detailsShowing" @change="row.toggleDetails">
								Mapa
							</b-form-checkbox>
						</template>
						<template #row-details="row">
							<b-card>
								<!----<map-zones :traceInfo="row.item" />-->
								<GeoDetailsRide :geoDetails="getGeoDetails(row)"></GeoDetailsRide>
							</b-card>
						</template>

					</b-table>
				</section>
			</b-modal>
		</MainLayout>
	</section>
</template>
<script>
    import MainLayout from '../../layout/MainLayout.vue'
    import moment from 'moment'
	import Multiselect from 'vue-multiselect'
	import helpers from '../helpers/Reports.js'
	import FilterSaleChannel from '../../../helpers/SaleChannelSelect'
	import GeoDetailsRide from "../../../helpers/Leaflet.vue";
    export default {
        name: "Index",
        components:{MainLayout,Multiselect,FilterSaleChannel,GeoDetailsRide},
		mixins:[helpers],
        data(){
            let pickUpStart = moment().subtract(7, 'days').format("YYYY-MM-DD");
            let pickUpEnd = moment().subtract(1, 'days').format("YYYY-MM-DD");
			const fields = [
					{ key: "serviceNumber", label: "ID" },
					{ key: "fullName", label: this.$t("users.name") },
					{ key: "saleChannelName", label: this.$t("bookings.salesChannel") },
					{ key: "pax", label: this.$t("bookings.paxes") },
					{ key: "pickupDatetime", label: this.$t("bookings.pickupDatetime") },
					{ key: "status", label: this.$t("users.status") },
					{ key: "serviceTypeName", label: this.$t("bookings.serviceType") },
					{ key: "revenue", label: this.$t("reports.rate") },
					{ key: "revenueCurrency", label: this.$t("reports.currency") },
					{ key: "promo", label: this.$t("reports.promo") },
					{ key: "pickupName", label: this.$t("bookings.pickup") },
					{ key: "dropoffName", label: this.$t("bookings.dropoff") }
			];


			const optsShow =[
				{value:10,text:10},
				{value:50,text:50},
				{value:100,text:100},
				{value:200,text:200},
				{value:500,text:500},
			]
			let columnsTrace =[
				{key:'ride',label:'Ride'},
				{key:'ratePlan',label:'Rate plan'},
				{key:'ratePlanStartDate',label:'F. Inicio'},
				{key:'ratePlanEndDate',label:'F. Fin'},
				{key:'zoneFrom',label:'Zona origen'},
				{key:'zoneTo',label:'Zona destino'},
				{key:'service',label:'Servicio venta'},
				{key:'msj',label:'Msj'},
				{key:'ratePlanId',label:'link'},
			]

            return {
				trace: {items:[],lastCalculated:-1,columns:columnsTrace},
				loading:false,
				loadingExport:false,
				loadingRow:false,
				filters:{
					pickupStartDate:pickUpStart,
					pickupEndDate:pickUpEnd,
					salesChannels:[],
					status:[],
					ratesInZero:false,
					withPromo: false
				},
				pagination:{
					perPage:10,
					currentPage:1,
					totalRows:0,
					perPageOptions:optsShow
				},
				tbl:{
					fields:fields,
					items:[],
				},
				grandTotal:{
					amount:0,
					currency:""
				},
				editing:false
			}
		},
		methods:{
			checkform(){
				this.pagination.currentPage =1;
				let errors = [];
				if(this.$root.isEmpty(this.filters.pickupStartDate) || this.$root.isEmpty(this.filters.pickupEndDate)){
					errors.push("Fecha inicio y fecha fin son requeridos");
				}
				if(errors.length===0){
					try{
						let startDate = moment(this.filters.pickupStartDate);
						let endDate   = moment(this.filters.pickupEndDate);
						this.dateRangeLimit(startDate,endDate)
						this.search();
					}catch(err){
						console.warn(err)
					}
                }else{
                    this.$root.showAlert(this.$t("reports.datesValidation"),{variant:'warning'});
                }
			},
			paginationChanged(){
				setTimeout(() => {
					if(this.pagination.perPage >50) this.deactivateEditing();
					this.search();
				},0);
			},
			search(){
				this.loading = true;
				this.$root.api.get(`reports/rides`,{
					params:{
						limit  :this.pagination.perPage,
						offset :this.offset,
						filters :this.filtersClean
					}
				}).then((res) => {
					this.tbl.items            = res.data.rows
					this.pagination.totalRows = res.data.totalRows
					this.grandTotal           = res.data.grandTotal
				})
				.catch(this.$root.handleRequestError)
				.finally(()=>{
					this.loading = false;
				})
			},
			exportSpreadSheet(){
				try{
					let startDate = moment(this.filters.pickupStartDate);
					let endDate   = moment(this.filters.pickupEndDate);
					this.dateRangeLimit(startDate,endDate)
				}catch(err){
					console.warn(err)
					return;
				}
				this.loadingExport = true
				this.$root.api.get(`reports/rides/`,{
					params:{
						filters:this.filtersClean,
						lang:this.$root.store.state.currentUser.lang,
						format:"spreadsheet"
					},
					responseType: "blob"
				}).then((res) => {
					this.downloadSpreadsheet(res,"Rides");
				}).catch(error => {
					this.$root.handleRequestError(error)
				}).finally(()=>{this.loadingExport = false});

			},
			getClassForStatus(status){
				let varClass = {
					noProvided: "text-danger",
					noShow:"text-warning",
					canceled:"text-secondary"
				};

				return varClass[status]??"";
			},
			downloadSpreadsheet(res, fileName) {
				let fileURL = window.URL.createObjectURL(new Blob([res.data]));
				let fileLink = document.createElement("a");
				fileLink.href = fileURL;
				fileLink.setAttribute("download", fileName + ".xlsx");
				document.body.appendChild(fileLink);
				fileLink.click();
				window.URL.revokeObjectURL(fileURL);
			},
			formatNumber(number) {
				// Convert number to string
				let strNumber = number.toString();

				// Split the string into integer and decimal parts (if any)
				let parts = strNumber.split(".");
				let integerPart = parts[0];
				let decimalPart = parts[1];

				// Add commas to the integer part
				let formattedNumber = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ",");

				// Combine the integer and decimal parts (if any)
				if (decimalPart) {
					formattedNumber += "." + decimalPart;
				}

				return formattedNumber;
			},
			calculatePrice(item) {
				this.loadingRow = item.id;
				this.trace.lastCalculated = -1;
				this.trace.items = [];
				this.$root.api
				.get(`/rates/supplier-prices/${item.id}`)
				.then(res => {
					this.trace.lastCalculated      = item.id
					item.supplierPriceTotalUpdated = res.data.supplierPriceTotal;
					item.supplierCurrency = res.data.supplierCurrency;
					this.loadingRow = -1;
					
					//Add
					this.trace.items = res.data.trace??[];
					this.trace.items = this.trace.items.map(v => ({...v, _showDetails: true}))
				})
				.catch(err => {
					this.loadingRow = -1;
					if(err.response.data.trace) this.trace.items = [...err.response.data.trace];
					this.$root.showAlert(this.$t("reports.rateNotFound"), { variant: "danger" });

				}).finally(()=>{
					this.trace.lastCalculated = item.id
				})
			},
			openModalTrace(){
				this.$refs["trace-data"].show()
			},
			getGeoDetails(row){
				try{
					return [row.item.supplierGeoDetails]
				}catch(err){
					console.log(err)
				}
				return [];
			},
			updateAllView() {
				if(!(this.ridesToUpdate.length>0)) {
					this.$root.showAlert("No hay rides a actualizar", { variant: "danger" });
					return;
				}
				this.$root.showWarning({
					message:this.ridesToUpdate.length+" rides serán actualizados, DESEA CONTINUAR?",
					okAction: (event, setLoading, close) => {
						setLoading(true);
						this.$root.api
							.put(`/rates/calculated-rides/update`, {transportServices: this.ridesToUpdate})
							.then(() => {
								this.$root.showAlert(
									this.$t("global.doneSuccessfully")
								);
								this.doneSaving();
								/*this.$root.$emit(
									"bv::refresh::table",
									"supplier-prices-index-list"
								);*/
								close();
							})
							.catch(err => {
								console.log(err)
								this.$root.showAlert(this.$t("global.genericError"), { variant: "danger" });
								close();
							});
					}
				});
			},
			activateEditing(){
				// Define the new item
				const newItem = { key: "revenueCalculate", label: this.$t("reports.calculateRate") };

				// Find the index of 'revenueCurrency'
				const index = this.tbl.fields.findIndex(field => field.key === "revenueCurrency");

				// Add the new item after 'revenueCurrency'
				if (index !== -1) {
					this.tbl.fields.splice(index + 1, 0, newItem);
				}
				this.editing=true;
				console.log( this.tbl.fields); // Verify the updated array
			},
			deactivateEditing(){
				// Define the key of the item to remove
				const keyToRemove = "revenueCalculate";

				// Find the index of the item with the specified key
				const index = this.tbl.fields.findIndex(field => field.key === keyToRemove);

				// Remove the item if it exists
				if (index !== -1) {
					this.tbl.fields.splice(index, 1);
				}
				this.editing=false;
			},
			doneSaving(){
				this.paginationChanged();
				this.deactivateEditing();
				this.trace.items=[];
				this.trace.lastCalculated=-1
			}
		},
		computed:{
			filtersClean(){
				let filters = {...this.filters};
				if(!this.$root.isEmpty(filters.status)){
					filters.status = filters.status.map((ele)=>{
						return ele.value;
					})
				}
				return filters;
			},
			offset(){
				let offset = this.pagination.perPage * (this.pagination.currentPage - 1 );
				return offset;
			},
			statusOpts() {
				return [{
					group: this.$t('global.selectAll'),
					options: this.$root.auxVars.transportServiceStatusOpts.map(opt => ({
						value: opt.value,
						text: this.$t(`bookings.serviceStatusOpts.${opt.value}`)
					}))
				}]
			},

			rowsMessage() {
				return this.$t("global.ajaxTable.showingNRecords", {
					from: this.offset+1,
					to: Math.min(this.offset+this.pagination.perPage,this.pagination.totalRows) ,
					total: this.pagination.totalRows
				});
			},
			willBePaidText(){
				let floatAmount = parseFloat(this.grandTotal.amount).toFixed(2)
				floatAmount     = this.formatNumber(floatAmount);
				return "$"+floatAmount +" "+this.grandTotal.currency.toUpperCase()
			},
			ridesToUpdate(){
				let toUpdate = this.itemsRides
				.filter(item => !this.$root.isEmpty(item.supplierPriceTotalUpdated)) // Osnly include items with supplierPriceTotalUpdated
				.map(item => ({
					id: item.id,
					supplierPriceTotal: item.supplierPriceTotalUpdated,
					supplierCurrency: item.supplierCurrency
				}));
				return toUpdate;
			}, 
			itemsRides(){
				return this.tbl.items
			}

		},
		mounted(){
			if(!this.$root.userCan('revenue')) this.$router.push('/')
			this.search();
        },
    }
</script>


